import { APP, CITIES } from "../../constants";

const defaultState = APP.defaultState;

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case CITIES.FETCH:
            return { ...defaultState, isLoading: true };

        case CITIES.FETCH_SUCCESS:
            return { ...defaultState, results: action.payload };

        case CITIES.FETCH_FAILURE:
            return { ...defaultState, error: action.payload };

        default:
            return state;
    }
}
